import PropTypes from 'prop-types';
import { m } from 'framer-motion';
import { useState, useEffect } from 'react';
// @mui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

export default function TypewriterText({ texts, sx, ...other }) {
    const [index, setIndex] = useState(0);
    const [subIndex, setSubIndex] = useState(0);
    const [reverse, setReverse] = useState(false);
    const [blink, setBlink] = useState(true);

    // Blinking cursor
    useEffect(() => {
        const timeout2 = setTimeout(() => {
            setBlink((prev) => !prev);
        }, 500);
        return () => clearTimeout(timeout2);
    }, [blink]);

    // Typing logic
    useEffect(() => {
        if (index === texts.length) {
            setIndex(0);
            return;
        }

        if (subIndex === texts[index].length + 1 && !reverse) {
            setReverse(true);
            return;
        }

        if (subIndex === 0 && reverse) {
            setReverse(false);
            setIndex((prev) => (prev + 1) % texts.length);
            return;
        }

        const timeout = setTimeout(() => {
            setSubIndex((prev) => prev + (reverse ? -1 : 1));
        }, Math.max(reverse ? 50 : subIndex === texts[index].length ? 2000 : 100, parseInt(Math.random() * 100)));

        return () => clearTimeout(timeout);
    }, [subIndex, index, reverse, texts]);

    return (
        <Box sx={{ display: 'inline-flex', minHeight: '64px', ...sx }} {...other}>
            <Typography variant="h2" sx={{ color: 'inherit', fontWeight: 'bold' }}>
                {`${texts[index].substring(0, subIndex)}${blink ? '|' : ' '}`}
            </Typography>
        </Box>
    );
}

TypewriterText.propTypes = {
    texts: PropTypes.arrayOf(PropTypes.string).isRequired,
    sx: PropTypes.object,
};
